import { styled } from "@linaria/react";
import { cssIsActive, getCustomizeScroll } from "@/styles/utils/Utils";
import { breakpoints, colors } from "@/styles/utils/vars";
import { cssIcon } from "@/ui/Icon";
import { StyledLinkBase } from "@/ui/Link/StyledLink";
import { cssDialog } from "@/ui/Modal/StyledModal";
import { getTypographyBase, Paragraph12 } from "@/ui/Typography/Typography";
import { StyledAvailable } from "../../Available/StyledAvailable";
export const Content = /*#__PURE__*/styled('div')({
  name: "Content",
  class: "Content_cmrsfoh"
});
export const StyledAddress = /*#__PURE__*/styled(Paragraph12)({
  name: "StyledAddress",
  class: "StyledAddress_s1c92izw"
});
export const StyledSchedule = /*#__PURE__*/styled(Paragraph12)({
  name: "StyledSchedule",
  class: "StyledSchedule_s8i2znc"
});
export const StyledShopList = /*#__PURE__*/styled('div')({
  name: "StyledShopList",
  class: "StyledShopList_s1d2ty1v"
});
export const StyledShop = /*#__PURE__*/styled('div')({
  name: "StyledShop",
  class: "StyledShop_s1bb1hft"
});

require("./StyledShop.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledShop.tsx");